import { Component, Input, Output, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';

import { AuthGuardService, CommercialService, UserService } from '@core/services';
import { Commercial, User } from '@shared/models';

@Component({
    selector: 'app-currency',
    templateUrl: './currency.component.html',
    styleUrls: ['./currency.component.css']
})
export class CurrencyComponent implements OnInit, OnDestroy {

    @Input('currencyGroup')
    public currency: FormGroup;

    @Output('update')
    switched: EventEmitter<any> = new EventEmitter();

    public programs: any;
    public currencyOptions: any;
    public commercial: any;
    private user: User;

    subscription: Subscription;
    commercialSubscription: Subscription;

    constructor(private _userService: UserService,
        private _authGuard: AuthGuardService,
                private _fb: FormBuilder,
                private _commercial: CommercialService) {
        this.currency = this._fb.group({
            ProgramTypeId: new FormControl()
        })
    }


    ngOnInit() {

        this.commercialSubscription = this._commercial.getCommercialValue().subscribe(commercial =>{
            this.commercial = commercial;
        });

        this.subscription = this._userService.getUser().subscribe(user => {
            this.user = user;
        if(this.user.accountSummaryArray){
          if(this.user.accountSummaryArray.length > 0){
            this.getProgramTypes();
          }
        }
        });


        this.getProgramTypes();
    }

    ngOnDestroy(){
      if(this.subscription)
        this.subscription.unsubscribe();
      if(this.commercialSubscription)
        this.commercialSubscription.unsubscribe();
    }

    private getProgramTypes() {
        this._authGuard.authenticatedPost('portfolios/NexpressProgramTypes', { "IsCommercial": this.commercial.isCommercialDomain}).subscribe(
            result => {
                let programResult: any;
                programResult = result;
                this.programs = programResult.NexpressProgramTypes;
                console.log(this.programs);
                this.currencyOptions = []
                this.programs.forEach(element => {
                    if (!(this.currencyOptions.filter(e => e.CurrencyType === element.CurrencyType).length > 0)){
                      this.currencyOptions.push({Id: element.Id, CurrencyType: element.CurrencyType})
                    }
                });
                this.currencyOptions.sort((a,b) => { return a.CurrencyType > b.currencyType})
                console.log(this.currencyOptions);
                this.setDefaults();
            },
            error => console.log('get program types Error:', error)
        );
    }

    private setDefaults() {
      if(this.user.accountSummaryArray){
        if (this.user.accountSummaryArray.length > 0) {
            this.currency.patchValue({
                ProgramTypeId: this.user.accountSummaryArray[this.user.accountIndex].ProgramType
            });
        }
}
    }

    public switchProgram(programType: any){
        for(let program of this.programs)
        {
            if(program.Id == programType)
            {
                this.switched.emit(program);
                break;
            }

        }
    }

}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/currency/currency.component.ts